import classNames from "classnames";
import Styles from "./Service.module.scss";
import Navbar from "../../Component/Navbar/Navbar";
import SubTitle from "../../Component/Text/SubTitle";
import Footer from "../../Component/Footer/Footer";
import img1 from "../../assets/images/service/長照居家困境協助.jpg";

const DistressAssistance = () => {
  return (
    <div>
      <Navbar />
      <div style={{ padding: "10vh" }} className={classNames("container")}>
        <SubTitle text={`長照居家困境協助`} />
        <div
          className={classNames(Styles.service__item)}
          style={{ paddingTop: "2vh", paddingBottom: "5vh" }}
        >
          <h5 className={classNames(Styles.service__item__title)}>
            長照居家困境協助
          </h5>

          <p className={classNames(Styles.service__item__param)}>
            感謝花蓮縣吉安鄉東龍宮文化發展協會等時常捐贈物資，讓本會定期至基本的生活所需常無法維持需要協助的家庭，陪伴老人分發物資給長者溫暖和支持。
          </p>
          <div className={classNames("col-12", Styles.service__img__wrapper)}>
            <img
              src={img1}
              alt="長照居家困境協助.jpg"
            />
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};
export default DistressAssistance;
